import React, { Component } from "react";
import ReactDOM from "react-dom";
import Tooltip from "react-tooltip-lite";

import { FullRow, Row, Col } from "../../framework/Grid";
import {
  Dialog,
  Checkbox,
  IconButton,
  Popover as MaterialPopover,
  RaisedButton,
} from "material-ui";
import AddLocation from "./Geography/AddLocation";
import AutoMake from "./AutoMake/AutoMake";
import CultureCode from "./CultureCode/CultureCode";

import SelectedAttrs from "../SelectedAttrs";
import MapSelector from "../Map";
import LimitExceededForm from "../Forms/LimitExceeded";

import {
  map,
  sortBy,
  forEach,
  last,
  groupBy,
  flattenDeep,
  isEmpty,
  isUndefined,
} from "lodash";
import {
  text_definition,
  primaryColor,
  debounceEventHandler,
} from "../../../utils/utility";
import {
  parseSegment,
  parsePlottedValues,
  parseZipcode,
  attr2Rules,
} from "../../../utils/segment_util";
import ActionInfo from "material-ui/svg-icons/action/info-outline";
import NavigationMoreHoriz from "material-ui/svg-icons/navigation/more-horiz";
import { Menu, MenuItem, Typeahead } from "react-bootstrap-typeahead";
import { splitNumber, getUrlParameterByName } from "../../../utils/utility";

import "./segment_creation.css";
const styles = {
  tooltipStyle: {
    textAlign: "left",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "200",
    padding: "20px 30px",
  },
  helpIconStyle: {
    marginTop: "-25px",
    width: "28px",
    height: "28px",
  },
  checkbox: {
    fontSize: "1.1em",
    fill: "#26A69A",
  },
  checkboxLabel: {
    color: "black",
    width: "auto",
    fontSize: "1.2em",
  },
  checkboxHighlightLabel: {
    color: "black",
    fontSize: "1.2em",
    width: "auto",
    backgroundColor: "lightgrey",
  },
};
const MenuDivider = props => <li className="divider" role="separator" />;
const MenuHeader = props => <li {...props} className="dropdown-header" />;
class Creation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pairKeys: {},
      key: "",
      openValuesDialog: false,
      openSelectedDialog: false,
      openMapDialog: false,
      openCancel: false,
      openReset: false,
      selectKeyPair: {},
      selected_segments: [],
      highlightId: 0,
      highlightAid: 0,
      hightlightCid: 0,
      ifShowState: "", // if show state/city selection
      ifShowAutoMake: false,
      ifShowCultureRegion: false,
      errorVisible: false,
      toolTipStatus: false,
      resetAllCount: false,
      mapKey: Math.floor(Date.now() / 1000),
      showSaveErrorDialog: false,
      openContactForm: false,
      showSuccessForm: false,
    };
    if (!props.demoAttributes) {
      props.loadAttributes(getUrlParameterByName("cid"));
    }
    if (!props.segment_name) {
      props.clearAudienceCount();
    }
    /*
    if (!props.selected_client || parseInt(props.selected_client, 10) < 1) {
      window.location.href = "/";
    }*/
    const cid = getUrlParameterByName("cid");
    if (cid) {
      this.props.selectClient(parseInt(cid, 10));
    }
  }

  componentDidMount() {
    const width = document.getElementById("CreateSegment").clientWidth;
    this.setState({ width: width, isNameDuplicated: false });
    this.props.getAllStates(); //get all states
    this.props.getAllStateCities(); // get all states and cities
    this.props.loadCounties();
    this.props.loadDMAs();
    if (
      (this.props.selected_city && this.props.selected_city.length > 0) ||
      (this.props.selected_state && this.props.selected_state.length > 0) ||
      (this.props.selected_county && this.props.selected_county.length > 0) ||
      (this.props.selected_dma && this.props.selected_dma.length > 0) ||
      (this.props.zipcode && this.props.zipcode.length > 0) ||
      this.props.plotted_values
    ) {
      document.getElementById("cat-geography-item-group_link").click();
      if (
        (this.props.selected_city && this.props.selected_city.length > 0) ||
        (this.props.selected_state && this.props.selected_state.length > 0) ||
        (this.props.selected_county && this.props.selected_county.length > 0) ||
        (this.props.selected_dma && this.props.selected_dma.length > 0) ||
        (this.props.zipcode && this.props.zipcode.length > 0)
      )
        this.setState({ ifShowState: true });
    } else {
      const { selected_segments, demoAttributes } = this.props;
      if (
        this.props.selected_segments &&
        this.props.selected_segments.length > 0
      ) {
        map(demoAttributes, cat => {
          const group_id = "cat-attr-" + cat.id + "-item-group";
          const link_id = group_id + "_link";
          let hit = false;
          let attrId = 0;
          map(cat.attributes, attr => {
            map(attr.values, val => {
              if (selected_segments.indexOf(val.id) >= 0) {
                hit = true;
                attrId = attr.id;
                this.setState({
                  highlightAid: val.id,
                  hightlightCid: cat.id,
                  selectKeyPair: attr,
                });
              }
            });
            map(attr.subAttributes, subAttr => {
              map(subAttr.values, val => {
                if (selected_segments.indexOf(val.id) >= 0) {
                  hit = true;
                  attrId = attr.id;
                  this.setState({
                    highlightAid: val.id,
                    hightlightCid: cat.id,
                    selectKeyPair: attr,
                  });
                }
              });
            });
          });

          if (hit === true) {
            document.getElementById(link_id).click();
            if (attrId === 605 || attrId === 606) {
              //auto make / auto model
              this.setState({
                ifShowAutoMake: true,
                ifShowCultureRegion: false,
                ifShowState: false,
              });
            } else if (attrId === 1502 || attrId === 1503) {
              this.setState({
                ifShowAutoMake: false,
                ifShowCultureRegion: true,
                ifShowState: false,
              });
            } else {
              this.setState({
                ifShowCultureRegion: false,
                ifShowState: false,
                ifShowAutoMake: false, // close auto make panel
              });
            }
            return;
          }
        });
      }
    }

    const clearAll = window.sessionStorage.getItem("clearAll");
    if (clearAll) {
      window.sessionStorage.removeItem("clearAll");
      this.clearAllSelected();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected_client !== this.props.selected_client) {
      if (nextProps.selected_client > 1) {
        let url = "/segment/create?cid=" + nextProps.selected_client;
        this.props.history.push(url);
      }
    }
    if (nextProps.isNameDuplicated === true) {
      if (!this.state.errorVisible) this.setState({ errorVisible: true });
    } else {
      if (this.state.errorVisible === true)
        this.setState({ errorVisible: false });
    }

    if (nextProps.audience_total_count !== this.props.audience_total_count) {
      this.setState({
        onCalculating: false,
      });
    }

    if (
      nextProps.save_segment_success === false &&
      this.props.save_segment_success !== nextProps.save_segment_success
    ) {
      if (String(nextProps.save_segment_error_errorNo) === "422004")
        this.setState({
          showSaveErrorDialog: true,
          openContactForm: false,
        });
    }

    if (
      nextProps.request_assist_successful !==
      this.props.request_assist_successful
    ) {
      if (nextProps.request_assist_successful === true) {
        this.setState({
          showSuccessForm: true,
          openContactForm: false,
          showSaveErrorDialog: false,
        });
      }
    }

    if (
      nextProps.check_client_limit === true &&
      nextProps.check_client_limit !== this.props.check_client_limit
    ) {
      this.props.verifySegmentNameAndContinue(
        this.props.selected_client,
        this.props.segment_name,
      );
    }

    if (nextProps.targetHouseholdsOnly !== this.props.targetHouseholdsOnly) {
      this.reCalculateTotal(nextProps.targetHouseholdsOnly);
    }
  }

  handleOpen = () => {
    this.setState({ openValuesDialog: true });
  };

  handleClose = () => {
    this.setState({ openValuesDialog: false });
  };

  handleCancel = () => {
    this.setState({
      openValuesDialog: false,
      selected_segments: this.props.selected_segments
        ? this.props.selected_segments.slice()
        : [],
    });
  };

  toggleSelectedAttrDialog = e => {
    e.preventDefault();
    const display = !this.state.openSelectedDialog;
    this.setState({
      openSelectedDialog: display,
      sltAttrAnchorEl: e.currentTarget,
    });
  };

  closeSelectedAttrDialog = () => {
    this.setState({ openSelectedDialog: false });
  };

  loadValues(key) {
    const { demoAttributes, selected_segments } = this.props;
    if (demoAttributes) {
      this.setState({
        pairKeys: sortBy(demoAttributes[key].segments, segment => {
          return segment.label;
        }),
        key: key,
        selected_segments: selected_segments ? selected_segments.slice() : [],
      });
    }
  }

  getLanguageGroup(val) {
    if (val.indexOf("HL") >= 0) {
      return "Hispanic Language Usage";
    }
    if (val.indexOf("AL_CN") >= 0) {
      return "Chinese Language Usage";
    }
    if (val.indexOf("AL_IN") >= 0) {
      return "Indic Language Usage";
    }
    if (val.indexOf("AL_JP") >= 0) {
      return "Japanese Language Usage";
    }
    if (val.indexOf("AL_VN") >= 0) {
      return "Vietnamese Language Usage";
    }
    if (val.indexOf("AL_KR") >= 0) {
      return "Korean Language Usage";
    }
    if (val.indexOf("HA") >= 0) {
      return "Hispanicity";
    }
    if (val.indexOf("AA") >= 0) {
      return "Asianicity";
    }
  }
  displayAttrValues() {
    const values = this.state.selectKeyPair.values
      ? this.state.selectKeyPair.values
      : null;
    const subAttributes = this.state.selectKeyPair.subAttributes
      ? this.state.selectKeyPair.subAttributes
      : null;
    if (values == null && subAttributes == null) return;
    const rows = [];
    const selected_segments = this.props.selected_segments;
    let granularity = "";

    if (values) {
      map(this.props.demoAttributes, cat => {
        map(cat.attributes, attr => {
          if (
            parseInt(attr.id, 10) === parseInt(this.state.selectKeyPair.id, 10)
          ) {
            granularity = attr.granularity;
          }
        });
      });
      map(values, val => {
        const cols = [];
        const id = val.id;
        const _checked =
          selected_segments && selected_segments.indexOf(id) >= 0;

        cols.push(
          <Col key={"select-key-pair-" + id} xs="10" md="10" sm="10" lg="10">
            <Checkbox
              autoFocus={this.state.highlightId === id}
              inputStyle={{ width: "35px" }}
              label={
                (id.toString().indexOf("140") === 0 &&
                  id.toString().indexOf("1407") < 0 &&
                  id.toString().indexOf("1408") < 0) ||
                id.toString().indexOf("1505") === 0 ||
                id.toString().indexOf("1504") === 0 ? (
                  <Tooltip
                    content={
                      <div
                        className="p-10 black-border"
                        style={{ background: "#FFF" }}
                      >
                        {granularity}
                      </div>
                    }
                    direction="right"
                  >
                    <div style={{ paddingLeft: "20px", display: "flex" }}>
                      <div
                        style={{
                          width:
                            id.toString().indexOf("1504") === 0
                              ? "30px"
                              : "60px",
                          display:
                            id.toString().indexOf("1505") === 0
                              ? "inline-block"
                              : "inline",
                        }}
                      >
                        {val.value}
                      </div>
                      <div
                        style={{
                          marginLeft:
                            id.toString().indexOf("1505") === 0
                              ? "40px"
                              : "60px",
                        }}
                      >
                        {val.label}
                      </div>
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip
                    content={
                      <div
                        className="p-10 black-border"
                        style={{ background: "#FFF" }}
                      >
                        {granularity}
                      </div>
                    }
                    direction="right"
                  >
                    <span className="ml-20">{val.label}</span>
                  </Tooltip>
                )
              }
              labelStyle={
                this.state.highlightId === id
                  ? styles.checkboxHighlightLabel
                  : styles.checkboxLabel
              }
              defaultChecked={_checked}
              iconStyle={styles.checkbox}
              onCheck={e => {
                this.chooseSegmentValues(id);
              }}
            />
          </Col>,
        );

        cols.push(
          <Col xs="2" md="2" sm="2" lg="2" key={"value-pairs-col-" + id}>
            <p
              className="text-default text-size-large"
              style={{ fontSize: "1.2em" }}
            >
              &nbsp;
            </p>
          </Col>,
        );
        if (id.toString().indexOf("140") === 0 && rows.length <= 0) {
          rows.push(
            <Row
              style={{
                /*padding: 0, margin: "20px 20px 0 20px"*/ marginBottom:
                  "-20px",
              }}
              key={"select-key-pair-row-" + id}
            >
              <Col
                key={"key-pair-title-" + id}
                xs="10"
                md="10"
                sm="10"
                lg="10"
                className="mb-20"
              >
                <div
                  style={{
                    height: "40px",
                    paddingTop: "10px",
                    background: "#E8E8E8",
                    marginLeft: "40px",
                  }}
                >
                  <span style={{ marginLeft: "20px" }}>
                    <strong>
                      {id.toString().indexOf("1504") === 0 ? "Code" : "Segment"}
                    </strong>
                  </span>
                  {id.toString().indexOf("1408") < 0 &&
                    id.toString().indexOf("1407") < 0 && (
                      <span style={{ marginLeft: "60px" }}>
                        <strong>{"Segment Name"}</strong>
                      </span>
                    )}
                </div>
              </Col>
              <Col xs="2" md="2" sm="2" lg="2" key={"key-pairs-title2-" + id}>
                <p
                  className="text-default text-size-large"
                  style={{ fontSize: "1.2em" }}
                >
                  &nbsp;
                </p>
              </Col>
              {cols}
            </Row>,
          );
        } else {
          if (
            (id.toString().indexOf("1505") === 0 ||
              id.toString().indexOf("1504") === 0) &&
            val.value.endsWith("1")
          ) {
            rows.push(
              <Row
                style={{ marginBottom: "-20px" }}
                key={"select-key-pair-row-" + id + "-title"}
              >
                <Col
                  key={"key-pair-title-" + id + val.value}
                  xs="10"
                  md="10"
                  sm="10"
                  lg="10"
                  className="mb-20"
                >
                  <div
                    style={{
                      height: "40px",
                      paddingTop: "10px",
                      background: "#E8E8E8",
                      marginLeft: "40px",
                    }}
                  >
                    <span style={{ marginLeft: "20px" }}>
                      <strong>Code</strong>
                    </span>
                    <span style={{ marginLeft: "60px" }}>
                      <strong>{this.getLanguageGroup(val.value)}</strong>
                    </span>
                  </div>
                </Col>
                {cols}
              </Row>,
            );
          } else {
            rows.push(
              <Row
                style={{ marginBottom: "-20px" }}
                key={"select-key-pair-row-" + id}
              >
                {cols}
              </Row>,
            );
          }
        }
      });
    }
    if (subAttributes) {
      map(subAttributes, subAttr => {
        const cols = [];
        cols.push(
          <Col xs="4" md="4" sm="4" lg="4" key={"sub-attr-col-" + subAttr.id}>
            <p className="text-default text-size-large">{subAttr.name}</p>
          </Col>,
        );

        const subAttrRows = [];
        granularity = subAttr.granularity;
        map(subAttr.values, subAttrVal => {
          const id = subAttrVal.id;
          const _checked =
            selected_segments && selected_segments.indexOf(id) >= 0;
          subAttrRows.push(
            <FullRow
              key={"select-key-pair-row-" + id}
              className="no-padding no-margin"
            >
              <Checkbox
                autoFocus={this.state.highlightId === id}
                inputStyle={{ width: "35px" }}
                label={
                  <Tooltip
                    content={
                      <div
                        className="p-10 black-border"
                        style={{ background: "#FFF" }}
                      >
                        {granularity}
                      </div>
                    }
                    direction="right"
                  >
                    {subAttrVal.label}
                  </Tooltip>
                }
                labelStyle={
                  this.state.highlightId === id
                    ? styles.checkboxHighlightLabel
                    : styles.checkboxLabel
                }
                defaultChecked={_checked}
                iconStyle={styles.checkbox}
                onCheck={e => {
                  this.chooseSegmentValues(id);
                }}
              />
            </FullRow>,
          );
        });
        cols.push(
          <Col
            xs="8"
            md="8"
            sm="8"
            lg="8"
            key={"sub-attr-values-col-" + subAttr.id}
          >
            {subAttrRows}
          </Col>,
        );
        rows.push(
          <Row
            style={{ marginBottom: "-20px" }}
            key={"select-key-pair-row-" + subAttr.id}
          >
            {cols}
          </Row>,
        );
      });
    }
    return (
      <div
        style={{
          padding: "90px 5px 0 5px",
          height: "500px",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        {rows}
      </div>
    );
  }

  chooseSegmentValues(id) {
    let selected = this.props.selected_segments
      ? this.props.selected_segments
      : [];

    const idx = selected ? selected.indexOf(id) : -1;
    if (idx >= 0) {
      selected.splice(idx, 1);
    } else {
      selected.push(id);
    }
    this.props.selectSegment(selected);

    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      20,
    );
  }

  handleOpenCancelDialog(e, status) {
    e.preventDefault();
    this.setState({
      openCancel: status,
      cancelAnchorEl: e.currentTarget,
    });
  }

  clearAllSelected() {
    this.setState({
      highlightId: 0,
      highlightAid: 0,
      hightlightCid: 0,
      selectKeyPair: {},
      search_input: undefined,
    });
    this.props.selectSegment([]);
    this.setState({
      selected_segments: [],
      mapKey: Math.floor(Date.now() / 1000),
    });
    this.props.clearAllSelectedState();
    this.props.clearAllSelectedCity();
    this.props.clearAllZipCode();
    this.props.setPlotValues({});
    this.props.setSegmentName("");
    const segmentNameInput = ReactDOM.findDOMNode(this.refs.segmentNameInput);
    segmentNameInput.value = "";

    this.typeahead.getInstance().clear();
    // author chargo
    this.props.clearAudienceCount();
    const targetHouseholdsOnly = ReactDOM.findDOMNode(
      this.refs.targetHouseholdsOnly,
    );
    targetHouseholdsOnly.checked = false;
    this.props.setTargetHouseholdOnly(false);
    // author chargo
    const { demoAttributes } = this.props;
    map(demoAttributes, cat => {
      const group_id = "cat-attr-" + cat.id + "-item-group";
      const link_id = group_id + "_link";
      const node = ReactDOM.findDOMNode(this.refs[group_id]);
      if (node.classList.contains("in")) {
        document.getElementById(link_id).click();
      }
    });
    setTimeout(() => {
      const group_id = "cat-geography-item-group";
      const link_id = group_id + "_link";
      const node = ReactDOM.findDOMNode(this.refs[group_id]);
      if (node.classList.contains("in"))
        document.getElementById(link_id).click();
    }, 0);
    this.setState(
      {
        ifShowState: false,
      },
      () => {
        window.scrollTo(0, 0);
      },
    );
  }

  removeSelectedVal(id) {
    const { selected_segments } = this.props;
    const idx = selected_segments.indexOf(id);
    if (idx >= 0) {
      selected_segments.splice(idx, 1);
      this.props.selectSegment(selected_segments);
    }

    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      20,
    );
  }

  removePlottedVal() {
    this.props.setPlotValues({});
    setTimeout(() => {
      this.reCalculateTotal();
    }, 20);
  }

  handleOpenResetDialog(e, status) {
    e.preventDefault();
    this.setState({
      openReset: status,
      resetAnchorEl: e.currentTarget,
    });
  }

  calTotalAudience() {
    const {
      audience_total_count,
      demoAttributes,
      selected_segments,
      plotted_values,
      selected_state,
      selected_city,
      selected_county,
      selected_dma,
      zipcode,
      active_segment_attributes,
    } = this.props;
    // author chargo
    if (audience_total_count) return audience_total_count;
    if (!isEmpty(active_segment_attributes)) {
      return {
        total: active_segment_attributes.count,
        email: active_segment_attributes.email,
        display: active_segment_attributes.display,
        social: active_segment_attributes.social,
        directMail: active_segment_attributes.directMail,
      };
    }
    const plottedValues = this.state.plotted_values
      ? this.state.plotted_values
      : plotted_values;
    let result = { total: 0, email: 0, display: 0, social: 0, directMail: 0 };

    forEach(selected_segments, sid => {
      map(demoAttributes, cat => {
        map(cat.attributes, segment => {
          map(segment.values, val => {
            if (val.id === sid) {
              result.total += parseInt(val.total, 10);
              result.email += parseInt(val.email, 10);
              result.social += parseInt(val.social, 10);
              result.display += parseInt(val.display, 10);
              result.directMail += parseInt(val.directMail, 10);
            }
          });
          map(segment.subAttributes, subAttr => {
            map(subAttr.values, val => {
              if (val.id === sid) {
                result.total += parseInt(val.total, 10);
                result.email += parseInt(val.email, 10);
                result.social += parseInt(val.social, 10);
                result.display += parseInt(val.display, 10);
                result.directMail += parseInt(val.directMail, 10);
              }
            });
          });
        });
      });
    });
    if (plottedValues && plottedValues.audienceCount) {
      result.total += parseInt(plottedValues.audienceCount.total, 10);
      result.email += parseInt(plottedValues.audienceCount.email, 10);
      result.social += parseInt(plottedValues.audienceCount.social, 10);
      result.display += parseInt(plottedValues.audienceCount.display, 10);
      result.directMail += parseInt(plottedValues.audienceCount.directMail, 10);
    } else {
      result.total +=
        this.computedStateOrCityAttibute(selected_state, "total") +
        this.computedStateOrCityAttibute(selected_city, "total") +
        this.computedStateOrCityAttibute(zipcode, "total");
      this.computedStateOrCityAttibute(selected_county, "total");
      this.computedStateOrCityAttibute(selected_dma, "total");
      result.email +=
        this.computedStateOrCityAttibute(selected_state, "email") +
        this.computedStateOrCityAttibute(selected_city, "email") +
        this.computedStateOrCityAttibute(zipcode, "email");
      this.computedStateOrCityAttibute(selected_county, "email");
      this.computedStateOrCityAttibute(selected_dma, "email");
      result.social +=
        this.computedStateOrCityAttibute(selected_state, "social") +
        this.computedStateOrCityAttibute(selected_city, "social") +
        this.computedStateOrCityAttibute(zipcode, "social");
      this.computedStateOrCityAttibute(selected_county, "social");
      this.computedStateOrCityAttibute(selected_dma, "social");
      result.display +=
        this.computedStateOrCityAttibute(selected_state, "display") +
        this.computedStateOrCityAttibute(selected_city, "display") +
        this.computedStateOrCityAttibute(zipcode, "display");
      this.computedStateOrCityAttibute(selected_county, "display");
      this.computedStateOrCityAttibute(selected_dma, "display");
      result.directMail +=
        this.computedStateOrCityAttibute(selected_state, "directMail") +
        this.computedStateOrCityAttibute(selected_city, "directMail") +
        this.computedStateOrCityAttibute(zipcode, "directMail");
      this.computedStateOrCityAttibute(selected_county, "directMail");
      this.computedStateOrCityAttibute(selected_dma, "directMail");
    }
    /*
		if (selected_make && selected_make.length > 0){
			result.total += this.computedStateOrCityAttibute(selected_make, 'total')
			result.email += this.computedStateOrCityAttibute(selected_make, 'email')
			result.social += this.computedStateOrCityAttibute(selected_make, 'social')
			result.display += this.computedStateOrCityAttibute(selected_make, 'display')
		}
		if (selected_model && selected_model.length > 0){
			result.total += this.computedStateOrCityAttibute(selected_model, 'total')
			result.email += this.computedStateOrCityAttibute(selected_model, 'email')
			result.social += this.computedStateOrCityAttibute(selected_model, 'social')
			result.display += this.computedStateOrCityAttibute(selected_model, 'display')
		}
		*/
    return result;
  }

  generateClutureRegionItem(selected, attrCultureRegion, attrClutureLocale) {
    const { selected_segments } = this.props; //this.state.selected_segments
    let already_select = false;
    let count = 0;
    forEach(selected_segments, sid => {
      map(attrCultureRegion.values, val => {
        if (val.id === sid) {
          already_select = true;
          count += val.total;
        }
      });
      map(attrClutureLocale.values, val => {
        if (val.id === sid) {
          already_select = true;
          count += val.total;
        }
      });
    });

    return (
      <Row
        key={"attribute-" + attrCultureRegion.id}
        className="no-padding no-margin"
      >
        <Col
          xs="9"
          sm="9"
          md="9"
          lg="9"
          style={{ paddingLeft: "25px", paddingRight: "0px" }}
        >
          <a
            className={selected ? "font-12em text-teal " : "font-12em"}
            onClick={e => this.handleAttributeItemClick(e, attrCultureRegion)}
            style={{ width: "100%" }}
          >
            Region/Locale
          </a>
          <span className="text-muted text-light ml-10">
            <small>{count > 0 ? splitNumber(count + "")() : ""}</small>
          </span>
        </Col>
        <Col xs="3" sm="3" md="3" lg="3">
          <div className={selected ? "pull-right hide" : "pull-right"}>></div>
          <span className="text-teal-400">
            {already_select && <i className="icon-checkmark4 text-size-md " />}
          </span>
        </Col>
      </Row>
    );
  }

  generateAutoMakeItem(selected, attrAutoMake, attrAutoModel) {
    const { selected_segments } = this.props; //this.state.selected_segments
    let already_select = false;
    let count = 0;
    forEach(selected_segments, sid => {
      map(attrAutoMake.values, val => {
        if (val.id === sid) {
          already_select = true;
          count += val.total;
        }
      });
      map(attrAutoModel.values, val => {
        if (val.id === sid) {
          already_select = true;
          count += val.total;
        }
      });
    });

    return (
      <Row
        key={"attribute-" + attrAutoMake.id}
        className="no-padding no-margin"
      >
        <Col
          xs="9"
          sm="9"
          md="9"
          lg="9"
          style={{ paddingLeft: "25px", paddingRight: "0px" }}
        >
          <a
            className={selected ? "font-12em text-teal " : "font-12em"}
            onClick={e => this.handleAttributeItemClick(e, attrAutoMake)}
            style={{ width: "100%" }}
          >
            Auto Make/Model
          </a>
          <span className="text-muted text-light ml-10">
            <small>{count > 0 ? splitNumber(count + "")() : ""}</small>
          </span>
        </Col>
        <Col xs="3" sm="3" md="3" lg="3">
          <div className={selected ? "pull-right hide" : "pull-right"}>></div>
          <span className="text-teal-400">
            {already_select && <i className="icon-checkmark4 text-size-md " />}
          </span>
        </Col>
      </Row>
    );
  }

  generateItem(selected, attr, categoryId) {
    // filter `Auto Model`
    if (
      attr.id === 605 ||
      attr.id === 606 ||
      attr.id === 1502 ||
      attr.id === 1503
    ) {
      return;
    }
    const { selected_segments } = this.props; //this.state.selected_segments
    const attrSelectedSegments = [];
    let already_select = false;
    let count = 0;
    forEach(selected_segments, sid => {
      map(attr.values, val => {
        if (val.id === sid) {
          already_select = true;
          count += val.total;
          attrSelectedSegments.push(sid);
        }
      });
      if (attr.subAttributes) {
        map(attr.subAttributes, subAttr => {
          map(subAttr.values, val => {
            if (val.id === sid) {
              already_select = true;
              count += val.total;
              attrSelectedSegments.push(sid);
            }
          });
        });
      }
    });
    if (attrSelectedSegments.length > 1) {
      const rules = attr2Rules(
        attrSelectedSegments,
        this.props.demoAttributes,
        [],
      );
      if (rules.length > 1) {
        //this.props.getCategoryAudienceCount(attr.id, rules)
        count = this.props.catAudienceCounts
          ? this.props.catAudienceCounts[attr.id]
          : 0;
      }
    }
    if (attr.name === "Auto Make") {
      attr.name = "Auto Make/Model";
    }
    return (
      <Row key={"attribute-" + attr.id} className="no-padding no-margin">
        <Col
          xs="9"
          sm="9"
          md="9"
          lg="9"
          style={{ paddingLeft: "25px", paddingRight: "0px" }}
        >
          <a
            className={selected ? "font-12em text-teal " : "font-12em"}
            onClick={e => this.handleAttributeItemClick(e, attr)}
            style={{ width: "100%" }}
          >
            {attr.name}
          </a>
          <span className="text-muted text-light ml-10">
            <small>
              {already_select && count ? splitNumber(count + "")() : ""}
            </small>
          </span>
        </Col>
        <Col xs="3" sm="3" md="3" lg="3">
          <div className={selected ? "pull-right hide" : "pull-right"}>></div>
          <span className="text-teal-400">
            {already_select && <i className="icon-checkmark4 text-size-md " />}
          </span>
        </Col>
      </Row>
    );
  }

  onSearchInputChange(text) {
    this.setState({
      search_input: text,
    });
  }

  renderSearchMenu(results, menuProps) {
    let idx = 0;

    const equal_results = [];
    const other_results = [];
    map(results, result => {
      if (result.label.toUpperCase() === this.state.search_input.toUpperCase())
        equal_results.push(result);
      else other_results.push(result);
    });

    const match_grouped = groupBy(equal_results, r => r.parent);
    const match_items = Object.keys(match_grouped)
      .sort()
      .map(parent => {
        return [
          !!idx && <MenuDivider key={`${parent}-divider`} />,
          <MenuHeader key={`${parent}-header`}>{parent}</MenuHeader>,
          map(match_grouped[parent], obj => {
            const item = (
              <MenuItem key={idx} option={obj} position={idx}>
                {obj.label}
              </MenuItem>
            );

            idx++;
            return item;
          }),
        ];
      });

    const grouped = groupBy(other_results, r => r.parent);
    const items = Object.keys(grouped)
      .sort()
      .map(parent => {
        return [
          !!idx && <MenuDivider key={`${parent}-divider`} />,
          <MenuHeader key={`${parent}-header`}>{parent}</MenuHeader>,
          map(grouped[parent], obj => {
            const item = (
              <MenuItem key={idx} option={obj} position={idx}>
                {obj.label}
              </MenuItem>
            );

            idx++;
            return item;
          }),
        ];
      });

    return <Menu {...menuProps}>{[match_items, items]}</Menu>;
  }

  handleSearchChange(e) {
    this.setState({
      highlightId: 0,
      highlightAid: 0,
      hightlightCid: 0,
      selectKeyPair: {},
    });
    if (e) {
      const result = e[0];
      if (result) {
        this.setState({ highlightId: result["id"] });
        const { demoAttributes } = this.props;

        map(demoAttributes, cat => {
          const group_id = "cat-attr-" + cat.id + "-item-group";

          map(flattenDeep(cat.attributes), attr => {
            if (attr.id === result["id"]) {
              this.setState({ selectKeyPair: attr, hightlightCid: cat.id });
              ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
            }
            map(attr.values, val => {
              if (val.id === result["id"]) {
                this.setState({
                  highlightAid: val.id,
                  hightlightCid: cat.id,
                  selectKeyPair: attr,
                });
                ReactDOM.findDOMNode(this.refs[group_id]).style.height = "auto";
              }
            });
            map(attr.subAttributes, subAttr => {
              map(subAttr.values, val => {
                if (val.id === result["id"]) {
                  this.setState({
                    highlightAid: val.id,
                    hightlightCid: cat.id,
                    selectKeyPair: attr,
                  });
                  ReactDOM.findDOMNode(this.refs[group_id]).style.height =
                    "auto";
                }
              });
            });
          });
        });
      }
    }
  }

  generateCatNode(category, group_items) {
    const group_id = "cat-attr-" + category.id + "-item-group";
    const highlightBySearch = this.state.hightlightCid === category.id;
    return (
      <div
        className="list-group-item attr-cat-item "
        key={"group-div-" + group_id}
      >
        <div className="panel-heading " style={{ padding: "0px" }}>
          <p className="panel-title font-1em">
            <a
              data-toggle="collapse"
              id={group_id + "_link"}
              data-parent="#accordion-control"
              href={"#" + group_id}
              aria-expanded={highlightBySearch ? "true" : "false"}
              className={highlightBySearch ? "" : "collapsed"}
            >
              {category.name}
            </a>
          </p>
        </div>
        <div
          id={group_id}
          ref={group_id}
          aria-expanded={highlightBySearch ? "true" : "false"}
          className={
            highlightBySearch
              ? "panel-collapse collapse in"
              : "panel-collapse collapse"
          }
        >
          <div
            className="panel-body pt-5 pt-5  pr-5"
            style={{ paddingLeft: "0px" }}
          >
            {group_items}
          </div>
        </div>
      </div>
    );
  }
  displayCategoryNodes() {
    const { demoAttributes } = this.props;
    const result = [];

    map(demoAttributes, category => {
      let group_items = [];
      /*
      if (
        category.id === 14 &&
        this.props.client_info &&
        this.props.client_info.subscriptionTierId !== 4
      ) {
        return;
      }*/
      const attributes = category.attributes;
      forEach(attributes, attr => {
        const already_selected =
          this.state.selectKeyPair && this.state.selectKeyPair.id === attr.id;
        if (attr.id === 605) {
          attr.name = "Auto Make/Model";
          const attrAutoMake = attributes.find(function(item) {
            return item.id === 605;
          });
          const attrAutoModel = attributes.find(function(item) {
            return item.id === 606;
          });
          const auto_item_element = this.generateAutoMakeItem(
            already_selected,
            attrAutoMake,
            attrAutoModel,
          );

          group_items.push(auto_item_element);
        } else if (attr.id === 1502) {
          const attrCultureRegion = attributes.find(function(item) {
            return item.id === 1502;
          });
          const attrCultureLocale = attributes.find(function(item) {
            return item.id === 1503;
          });
          const auto_item_element = this.generateClutureRegionItem(
            already_selected,
            attrCultureRegion,
            attrCultureLocale,
          );

          group_items.push(auto_item_element);
        } else {
          const item_element = this.generateItem(
            already_selected,
            attr,
            attr.id,
          );

          group_items.push(item_element);
        }
      });

      const node_element = this.generateCatNode(category, group_items);
      result.push(node_element);
      if (category !== last(demoAttributes)) {
        result.push(
          <div
            key={"cat-divider-" + category.id}
            className="list-group-divider"
          />,
        );
      }
    });
    return result;
  }
  _handleCancelPlotted() {
    this.setState({
      plotted_values: null,
    });
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      50,
    );
  }

  handleApplyPlotted(val) {
    this.props.clearAllSelectedState();
    this.props.clearAllSelectedCity();
    this.props.clearAllZipCode();
    this.props.setPlotValues(val);
    this.setState({
      plotted_values: null,
    });
    const plottedRules = [];
    const rule = parsePlottedValues(val);
    if (rule) {
      plottedRules.push(rule);
      setTimeout(
        function() {
          this.props.getPlottedAudienceCount(
            {
              rules: plottedRules,
              filtered: {
                targetHouseholdsOnly: Boolean(this.props.targetHouseholdsOnly),
              },
            },
            this.props.segment_id,
          );
        }.bind(this),
        100,
      );
    }

    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      100,
    );
  }

  nextStep() {
    this.props.selectSegment(this.state.selected_segments);
  }

  closeMapSelectDialog = () => {
    this.setState({ openMapDialog: false, plotted_values: null });
    this.props.clearAudienceCount();
  };

  handleAddLocation(e) {
    e.preventDefault();
    this.setState({
      ifShowState: true,
    });
  }

  reCalculateTotal(targetOnly) {
    if (this.props.zipcode.length > 0) {
      this.setState({
        onCalculating: true,
      });
      const newSegment = parseZipcode(this.props, this.props.segment_name);
      this.props.getZipcodeAudienceCount(
        {
          rules: newSegment.rules,
          filtered: {
            targetHouseholdsOnly: !isUndefined(targetOnly)
              ? Boolean(targetOnly)
              : Boolean(this.props.targetHouseholdsOnly),
          },
        },
        this.props.segment_id,
      );
    }

    const newSegment = parseSegment(
      this.props,
      this.props.segment_name,
      this.state.plotted_values,
    );

    if (
      newSegment.rules.length > 0 ||
      this.props.selected_city.length > 0 ||
      this.props.selected_state.length > 0 ||
      this.props.zipcode.length > 0 ||
      this.props.selected_dma.length > 0 ||
      this.props.selected_county.length > 0 ||
      !isEmpty(this.props.plotted_values)
    ) {
      const {
        demoAttributes,
        getCategoryAudienceCount,
        targetHouseholdsOnly,
        segment_id,
      } = this.props;

      this.setState({
        onCalculating: true,
      });
      this.props.getAudienceCount(
        {
          rules: newSegment.rules,
          filtered: {
            targetHouseholdsOnly: !isUndefined(targetOnly)
              ? Boolean(targetOnly)
              : Boolean(targetHouseholdsOnly),
          },
        },
        this.props.segment_id,
      );

      demoAttributes.forEach(function(cat) {
        cat.attributes.forEach(function(attr) {
          const parentId = attr.id;
          const catRules = [];
          if (attr.subAttributes) {
            attr.subAttributes.forEach(function(subAttr) {
              const _r = newSegment.rules.find(function(rule) {
                return rule.attributeId === subAttr.id;
              });
              if (_r) catRules.push(_r);
            });
          }
          if (catRules.length > 0) {
            getCategoryAudienceCount(
              {
                rules: catRules,
                categoryId: parentId,
                filtered: {
                  targetHouseholdsOnly: !isUndefined(targetOnly)
                    ? Boolean(targetOnly)
                    : Boolean(targetHouseholdsOnly),
                },
              },
              segment_id,
            );
          }
        });
      });
    } else {
      if (this.state.plotted_values || this.props.zipcode.length > 0) {
        this.setState({
          onCalculating: true,
        });
        const newSegment = parseSegment(
          this.props,
          this.props.segment_name,
          this.state.plotted_values,
        );
        this.props.getAudienceCount(
          {
            rules: newSegment.rules,
            filtered: {
              targetHouseholdsOnly: !isUndefined(targetOnly)
                ? Boolean(targetOnly)
                : Boolean(this.props.targetHouseholdsOnly),
            },
          },
          this.props.segment_id,
        );
      } else {
        this.props.clearAudienceCount();
      }
    }
  }

  calCatetoryAudience(categoryId, selectedAttr) {}

  handleCountySelected(countyObj, label, isChecked) {
    this.props.selectCounty(countyObj, label, isChecked);
  }

  handleDMASelected(dmaObj, label, isChecked) {
    this.props.selectDMA(dmaObj, label, isChecked);
  }

  handleCitySelected(cityObj, label, isChecked) {
    this.props.selectCity(cityObj, label, isChecked);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      100,
    );
  }

  handleStateSelected(stateObj, isChecked) {
    this.props.selectState(stateObj, isChecked);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      100,
    );
  }

  handleZipcodeAdded(zipcode) {
    this.props.addZipCode(zipcode);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      100,
    );
  }

  handleAutoMakeSelected(makeObj, isChecked) {
    this.props.selectMake(makeObj, isChecked);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      200,
    );
  }

  handleAutoModelSelected(modelObj, isChecked) {
    this.props.selectModel(modelObj, isChecked);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      200,
    );
  }

  handleCultureRegionSelected(obj, isChecked) {
    this.props.selectCultureRegion(obj, isChecked);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      200,
    );
  }

  handleCultureLocaleSelected(obj, isChecked) {
    this.props.selectCultureLocale(obj, isChecked);
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      200,
    );
  }
  // filter right panel 111
  displayRightPanel() {
    if (this.state.ifShowState) {
      return (
        <AddLocation
          allstates={this.props.allstates}
          selected_city={this.props.selected_city}
          selected_county={this.props.selected_county}
          selected_dma={this.props.selected_dma}
          selected_state={this.props.selected_state}
          selectCity={this.handleCitySelected.bind(this)}
          selectCounty={this.handleCountySelected.bind(this)}
          reCalculateTotal={this.reCalculateTotal.bind(this)}
          selectDMA={this.handleDMASelected.bind(this)}
          selectState={this.handleStateSelected.bind(this)}
          getCities={this.props.getCities}
          counties={this.props.counties}
          dmas={this.props.dmas}
          allcities={this.props.allcities}
          addZipCode={this.handleZipcodeAdded.bind(this)}
          zipcode={this.props.zipcode}
          clearAllSelectedState={this.props.clearAllSelectedState}
          clearAllSelectedCity={this.props.clearAllSelectedCity}
          clearAllDMA={this.props.clearAllDMA}
          clearAllCounty={this.props.clearAllCounty}
          clearAllZipCode={this.props.clearAllZipCode}
          clearMapPlotted={() => {
            this.props.setPlotValues({});
          }}
          all_state_cities={this.props.all_state_cities}
          ifLoading={this.props.ifLoading}
        />
      );
    } else if (this.state.ifShowAutoMake) {
      return (
        <AutoMake
          demoAttributes={this.props.demoAttributes}
          selectMake={this.handleAutoMakeSelected.bind(this)}
          selected_make={this.props.selected_make}
          selectModel={this.handleAutoModelSelected.bind(this)}
          selected_model={this.props.selected_model}
          selectSegment={this.props.selectSegment}
          selected_segments={this.props.selected_segments}
          make_active_arr={this.props.make_active_arr}
          addMakeActive={this.props.addMakeActive}
        />
      );
    } else if (this.state.ifShowCultureRegion) {
      return (
        <CultureCode
          demoAttributes={this.props.demoAttributes}
          selectMake={this.handleCultureLocaleSelected.bind(this)}
          selected_make={this.props.selected_culture_locale}
          selectModel={this.handleCultureRegionSelected.bind(this)}
          selected_model={this.props.selected_culture_region}
          selectSegment={this.props.selectSegment}
          selected_segments={this.props.selected_segments}
          make_active_arr={this.props.region_active_arr}
          addMakeActive={this.props.addRegionActive}
        />
      );
    } else {
      return this.displayAttrValues();
    }
  }
  // control the Auto make been clicked
  handleAttributeItemClick(e, attr) {
    if (e.target.innerText === "Auto Make/Model") {
      this.setState({
        ifShowAutoMake: true,
        ifShowState: false,
        ifShowCultureRegion: false,
        selectKeyPair: attr,
      });
    } else if (e.target.innerText == "Region/Locale") {
      this.setState({
        ifShowAutoMake: false,
        ifShowState: false,
        ifShowCultureRegion: true,
        selectKeyPair: attr,
      });
    } else {
      this.setState({
        selectKeyPair: attr,
        ifShowState: false,
        ifShowCultureRegion: false,
        ifShowAutoMake: false, // close auto make panel
      });
    }
  }
  computedStateOrCityAttibute(storeData, property) {
    return storeData
      ? storeData.reduce((acc, curr) => acc + curr[property], 0)
      : 0;
  }

  gotoNext(e) {
    e.preventDefault();
    if (this.props.segment_id && this.props.segment_id !== "") {
      this.props.verifySegmentNameAndContinue(
        this.props.selected_client,
        this.props.segment_name,
        this.props.segment_id,
      );
    } else {
      this.props.verifyAndContinue(
        this.props.selected_client,
        this.props.segment_name,
      );
    }
  }

  updateAudienceCountWithPlotted(plottedRadius) {
    this.setState({
      plotted_values: plottedRadius,
    });
    setTimeout(
      function() {
        this.reCalculateTotal();
      }.bind(this),
      20,
    );
  }

  handleSegmentNameChange(e) {
    this.props.setSegmentName(e.target.value);
  }
  nextButtonHover(hasSelectedSegments) {
    if (!hasSelectedSegments || this.state.plotted_values != null) {
      this.setState({
        toolTipStatus: true,
      });
    }
  }
  nextButtonMouseOut() {
    this.setState({
      toolTipStatus: false,
    });
  }

  openContactFormClick(e) {
    e.preventDefault();
    this.setState({
      openContactForm: true,
      showSaveErrorDialog: false,
    });
  }

  onContactFormSubmit(e, subject, comments) {
    e.preventDefault();
    const postData = {
      clientId: this.props.selected_client,
      subject: subject.trim(),
      comment: comments.trim(),
      type: "upgrade",
      originationPage: "Audience Segment Maximum Threshold Overlay Message",
    };

    this.props.sendAssistRequest(postData);
  }

  cancelContactForm(e) {
    e.preventDefault();
    this.setState({
      openContactForm: false,
      showSaveErrorDialog: false,
    });
  }
  render() {
    const {
      selected_city,
      selected_state,
      selected_county,
      selected_dma,
    } = this.props;
    const viewSltAttrBtn = (
      <i
        className={
          this.state.openSelectedDialog
            ? "glyphicon glyphicon-chevron-down"
            : "glyphicon glyphicon-chevron-up"
        }
      />
    );
    const segmentNameOnChange = debounceEventHandler(
      this.handleSegmentNameChange.bind(this),
      500,
    );
    let sltAttrCount = 0;
    if (this.props.selected_segments && this.props.selected_segments.length > 0)
      sltAttrCount = this.props.selected_segments.length;
    if (!isEmpty(this.props.plotted_values)) sltAttrCount += 1;
    if (this.props.selected_state && this.props.selected_state.length > 0)
      sltAttrCount += this.props.selected_state.length;
    if (this.props.selected_city && this.props.selected_city.length > 0)
      sltAttrCount += this.props.selected_city.length;
    if (this.props.zipcode && this.props.zipcode.length > 0)
      sltAttrCount += this.props.zipcode.length;
    if (this.props.selected_county && this.props.selected_county.length > 0)
      sltAttrCount += this.props.selected_county.length;
    if (this.props.selected_dma && this.props.selected_dma.length > 0)
      sltAttrCount += this.props.selected_dma.length;
    const hasSelectedSegments = sltAttrCount > 0; //this.props.selected_segments && this.props.selected_segments.length > 0
    return (
      <div id="CreateSegment">
        <FullRow
          style={{
            marginTop: "-60px",
            marginLeft: "-30px",
            paddingBottom: "0px",
          }}
        >
          <h3>Create an Audience Segment</h3>
          <p className="font-12em no-margin-bottom">
            Select a combination of geographic and demographic attributes for
            your audience segment.
          </p>
        </FullRow>
        <div
          style={{
            minHeight: "500px",
            backgroundColor: "#CCC",
            padding: "10px 40px",
            marginTop: "15px",
          }}
        >
          <Row
            style={{
              margin: "0px",
              padding: "0px 0px 10px 0px",
              marginRight: "-20px",
            }}
          >
            <Col xs="8" sm="8" md="8" lg="8">
              &nbsp;
            </Col>
            <Col xs="4" sm="4" md="4" lg="4">
              <div className="pull-right">
                {sltAttrCount > 0 ? (
                  <a onClick={this.toggleSelectedAttrDialog}>
                    Attributes Added {sltAttrCount}&nbsp;&nbsp;{viewSltAttrBtn}
                  </a>
                ) : (
                  "Attributes Added "
                )}
              </div>
            </Col>

            <Dialog
              open={this.state.openSelectedDialog}
              onRequestClose={this.closeSelectedAttrDialog}
              modal={false}
              autoScrollBodyContent={true}
              contentStyle={{
                width: this.state.width + "px",
                maxWidth: "none",
              }}
              actions={[
                <a
                  className="btn btn-default btn-xlg legitRipple bg-teal-400"
                  style={{ marginRight: "56px" }}
                  onClick={this.closeSelectedAttrDialog}
                >
                  Close
                </a>,
              ]}
            >
              <div
                className="text-default no-padding no-margin"
                style={{ marginTop: "-40px !important" }}
              >
                <SelectedAttrs
                  selectedAttrs={this.props.selected_segments}
                  plottedRadius={this.props.plotted_values}
                  selected_state={this.props.selected_state}
                  selected_city={this.props.selected_city}
                  selected_county={this.props.selected_county}
                  selected_dma={this.props.selected_dma}
                  categories={this.props.demoAttributes}
                  clearAllSelectedCity={this.props.clearAllSelectedCity}
                  clearAllZipCode={this.props.clearAllZipCode}
                  clearZipCode={this.props.clearZipCode}
                  clearAllCounty={this.props.clearAllCounty}
                  clearAllDMA={this.props.clearAllDMA}
                  selectState={this.props.selectState}
                  selectCity={this.props.selectCity}
                  selectCounty={this.props.selectCounty}
                  selectDMA={this.props.selectDMA}
                  zipcode={this.props.zipcode}
                  width={this.state.width}
                  removeAttribute={this.removeSelectedVal.bind(this)}
                  removePlottedVal={this.removePlottedVal.bind(this)}
                  selected_make={this.props.selected_make}
                  selected_model={this.props.selected_model}
                />
              </div>
              <div
                className="pull-right"
                style={{
                  position: "absolute",
                  top: "40px",
                  left: this.state.width - 80 + "px",
                }}
              >
                <a onClick={this.closeSelectedAttrDialog}>
                  <i className="icon-cancel-square text-teal-400" />
                </a>
              </div>
            </Dialog>
          </Row>
          <Row
            className="no-padding"
            style={{
              backgroundColor: "#FFF",
              display: this.state.openMapDialog ? "block" : "none",
            }}
          >
            <div
              className="panel-body no-padding"
              style={{ maxHeight: "480px", overflow: "auto" }}
            >
              <MapSelector
                key={this.state.mapKey}
                onClose={this.closeMapSelectDialog}
                getAudienceCount={this.props.getAudienceCount}
                clearAudienceCount={this.props.clearAudienceCount}
                onUpdateAudienceCount={this.updateAudienceCountWithPlotted.bind(
                  this,
                )}
                onApplyChanges={this.handleApplyPlotted.bind(this)}
                onCancelChanges={this._handleCancelPlotted.bind(this)}
                plottedValue={this.props.plotted_values}
              />
            </div>
          </Row>
          <Row
            style={{
              backgroundColor: "#FFF",
              display: this.state.openMapDialog ? "none" : "block",
            }}
          >
            <Col xs="5" sm="5" md="5" lg="5">
              <FullRow className="no-margin no-padding pb-20 ">
                <span
                  className="input-group mt-5"
                  style={{ width: "100%", marginLeft: "-10px" }}
                >
                  <Typeahead
                    labelKey="label"
                    options={this.props.value_typehead}
                    placeholder="Find an Attribute"
                    minLength={1}
                    renderMenu={this.renderSearchMenu.bind(this)}
                    onChange={this.handleSearchChange.bind(this)}
                    onInputChange={this.onSearchInputChange.bind(this)}
                    ref={typeahead => (this.typeahead = typeahead)}
                  />
                  <div
                    className="form-control-feedback "
                    style={{ width: "54px" }}
                  >
                    <span className="text-uppercase no-padding no-margin">
                      search
                    </span>
                  </div>
                </span>
              </FullRow>
              <div
                className="panel-body border-right-slate border-right"
                style={{
                  maxHeight: "480px",
                  overflow: "auto",
                  paddingTop: "0px",
                  marginTop: "-20px",
                  paddingLeft: "0px",
                }}
              >
                <h2>Category</h2>
                <div
                  className="list-group panel-group-control mt-10"
                  style={{ fontSize: "1.2em !important" }}
                >
                  <div className="list-group-item attr-cat-item ">
                    <div className="panel-heading" style={{ padding: "0px" }}>
                      <p className="panel-title font-1em">
                        <a
                          data-toggle="collapse"
                          id="cat-geography-item-group_link"
                          data-parent="#accordion-control"
                          href={"#geograph_parent"}
                          aria-expanded="false"
                          className="collapsed full-width"
                        >
                          Geography
                          <span className="pull-right category-tips">
                            <Tooltip
                              direction={"right"}
                              content={
                                <div
                                  className="p-10 black-border"
                                  style={{ background: "#FFFF" }}
                                >
                                  {text_definition("state_category_tips")}
                                </div>
                              }
                            >
                              <span className="text-blue">Tips</span>
                            </Tooltip>
                          </span>
                        </a>
                      </p>
                    </div>

                    <div
                      id="geograph_parent"
                      className="panel-collapse collapse"
                      aria-expanded="false"
                      ref={"cat-geography-item-group"}
                    >
                      <div
                        className="panel-body pt-5 pb-10 pr-5"
                        style={{ paddingLeft: "25px" }}
                      >
                        <div className="add-location-parent clearfix">
                          <Col
                            xs="9"
                            sm="9"
                            md="9"
                            lg="9"
                            style={{ paddingLeft: 0 }}
                          >
                            <a
                              onClick={e => this.handleAddLocation(e)}
                              className="font-12em"
                            >
                              Add a Location
                            </a>
                            <span
                              className="text-muted text-light ml-10"
                              style={{
                                display:
                                  (this.props.selected_state &&
                                    this.props.selected_state.length > 0) ||
                                  (this.props.selected_city &&
                                    this.props.selected_city.length > 0) ||
                                  (this.props.zipcode &&
                                    this.props.zipcode.length > 0) ||
                                  (this.props.selected_county &&
                                    this.props.selected_county.length > 0) ||
                                  (this.props.selected_dma &&
                                    this.props.selected_dma.length > 0)
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              <small>
                                {this.props.zipcode_audience_count
                                  ? splitNumber(
                                      this.props.zipcode_audience_count.total,
                                    )()
                                  : splitNumber(
                                      this.computedStateOrCityAttibute(
                                        selected_state,
                                        "total",
                                      ) +
                                        this.computedStateOrCityAttibute(
                                          selected_city,
                                          "total",
                                        ) +
                                        this.computedStateOrCityAttibute(
                                          selected_county,
                                          "total",
                                        ) +
                                        this.computedStateOrCityAttibute(
                                          selected_dma,
                                          "total",
                                        ),
                                    )()}
                              </small>
                            </span>
                          </Col>
                          <Col
                            xs="3"
                            sm="3"
                            md="3"
                            lg="3"
                            style={{ paddingLeft: "5px" }}
                          >
                            <span
                              className="text-teal-400"
                              style={{
                                display:
                                  this.props.selected_state.length > 0 ||
                                  this.props.selected_city.length > 0 ||
                                  this.props.zipcode.length > 0 ||
                                  (this.props.selected_county &&
                                    this.props.selected_county.length > 0) ||
                                  (this.props.selected_dma &&
                                    this.props.selected_dma.length) > 0
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              <i className="icon-checkmark4 " />
                            </span>
                            <span
                              className="pull-right"
                              style={{
                                display: this.state.ifShowState
                                  ? "none"
                                  : "block",
                              }}
                            >
                              >
                            </span>
                          </Col>
                        </div>
                        <div className="plot-radius-parent">
                          <Col
                            xs="9"
                            sm="9"
                            md="9"
                            lg="9"
                            style={{ paddingLeft: 0 }}
                          >
                            <a
                              onClick={e => {
                                e.preventDefault();
                                this.setState({
                                  openMapDialog: true,
                                  ifShowState: false,
                                });
                              }}
                              className="font-12em"
                              style={{ float: "left" }}
                            >
                              Plot a Custom Radius
                            </a>
                            <span
                              className="text-muted text-light ml-10"
                              style={{
                                display:
                                  this.props.plotted_values &&
                                  this.props.plotted_values.audienceCount
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              <small>
                                {this.props.plotted_values &&
                                  this.props.plotted_values.audienceCount &&
                                  splitNumber(
                                    this.props.plotted_values.audienceCount
                                      .total + "",
                                  )()}
                              </small>
                            </span>
                          </Col>
                          <Col
                            xs="3"
                            sm="3"
                            md="3"
                            lg="3"
                            style={{ paddingLeft: "5px" }}
                          >
                            <span
                              className="text-teal-400"
                              style={{
                                display:
                                  this.props.plotted_values &&
                                  this.props.plotted_values.audienceCount
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              <i className="icon-checkmark4 " />
                            </span>
                            <span className="pull-right">></span>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="list-group-divider" />
                  {this.displayCategoryNodes()}
                </div>
              </div>
            </Col>
            <Col
              xs="7"
              sm="7"
              md="7"
              lg="7"
              className="value-list"
              style={{ paddingRight: "0px" }}
            >
              {this.displayRightPanel()}
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              marginLeft: "-10px",
              marginRight: "-10px",
              padding: "20px 0",
            }}
          >
            <div
              style={{
                width: "33%",
                paddingRight: "20px",
                flexShrink: "1",
              }}
            >
              <div className="target-primary-box">
                <Checkbox
                  ref={"targetHouseholdsOnly"}
                  label="Target Primary Decision Maker"
                  labelStyle={{ width: "115%" }}
                  defaultChecked={this.props.targetHouseholdsOnly}
                  onCheck={e => {
                    this.props.setTargetHouseholdOnly(e.target.checked);
                  }}
                />
              </div>
              <div className="audience-box">
                <label>Audience</label>
                {this.state.onCalculating === true ? (
                  <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
                ) : (
                  <input
                    className="full-width input-md text-default text-bold pl-5"
                    readOnly
                    value={
                      this.state.resetAllCount
                        ? 0
                        : splitNumber(this.calTotalAudience().total + "")()
                    }
                  />
                )}
              </div>
            </div>
            <div
              style={{
                flexGrow: "1",
              }}
            >
              <div className="reach-by-channel">
                <div>Reach by Channel</div>
                <div className="channel-icon-btn">
                  <IconButton
                    className="pull-right no-margin no-padding"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <NavigationMoreHoriz
                      className="text-grey-400"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </IconButton>
                </div>
              </div>
              <div className="channel-items">
                {/*
                <div className="channel-col">
                  <div className="channel-item">
                    <img
                      className="channel-icon"
                      src="/images/channel-icon0.png"
                    />
                    <strong>Direct Mail:</strong>
                    <span>
                      {this.state.resetAllCount
                        ? 0
                        : this.state.onCalculating === true
                        ? ""
                        : splitNumber(
                            this.calTotalAudience()["directMail"] + "",
                          )()}
                    </span>
                  </div>
                        </div>*/}
                <div className="channel-col">
                  <div className="channel-item">
                    <img
                      className="channel-icon"
                      src="/images/channel-icon1.png"
                    />
                    <strong>Display:</strong>
                    <span>
                      {this.state.resetAllCount
                        ? 0
                        : this.state.onCalculating === true
                        ? ""
                        : splitNumber(
                            this.calTotalAudience()["display"] + "",
                          )()}
                    </span>
                  </div>
                </div>
                <div className="channel-col">
                  <div className="channel-item">
                    <img
                      className="channel-icon"
                      src="/images/channel-icon2.png"
                    />
                    <strong>Social:</strong>
                    <span>
                      {this.state.resetAllCount
                        ? 0
                        : this.state.onCalculating === true
                        ? ""
                        : splitNumber(this.calTotalAudience()["social"] + "")()}
                    </span>
                  </div>
                </div>
                <div className="channel-col" style={{ paddingRight: 0 }}>
                  <div className="channel-item">
                    <img
                      className="channel-icon"
                      src="/images/channel-icon3.png"
                    />
                    <strong>Email:</strong>
                    <span>
                      {this.state.resetAllCount
                        ? 0
                        : this.state.onCalculating === true
                        ? ""
                        : splitNumber(this.calTotalAudience()["email"] + "")()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Row
            style={{ margin: "-20px -20px -30px -30px", paddingRight: "0px" }}
            className="border-top border-top-white "
          >
            <div
              style={{
                color: "#ff0000",
                display: this.state.errorVisible ? "block" : "none",
              }}
            >
              This segment name already exists, please enter a unique segment
              name to continue
            </div>
            <div className="input-group mb-20">
              <input
                ref="segmentNameInput"
                className="full-width input-lg pl-10"
                placeholder=" Name this Segment"
                maxLength={60}
                onFocus={e => {
                  this.setState({ errorVisible: false });
                }}
                onChange={segmentNameOnChange.bind(this)}
                defaultValue={this.props.segment_name}
              />
              {/*
              <TooltipNormal
                visible={this.state.errorVisible}
                animation="zoom"
                trigger={[]}
                arrowContent={<div className="rc-tooltip-arrow-inner" />}
                placement="top"
                overlay={
                  <span>
                    This segment name already exists, please enter a unique
                    segment name to continue
                  </span>
                }
              >

                <input
                  ref="segmentNameInput"
                  className="full-width input-lg pl-10"
                  placeholder=" Name this Segment"
                  maxLength={60}
                  onFocus={e => {
                    this.setState({ errorVisible: false });
                  }}
                  onChange={segmentNameOnChange.bind(this)}
                  defaultValue={this.props.segment_name}
                />
              </TooltipNormal>*/}
              <span className="input-group-addon">
                <Tooltip
                  direction={"left"}
                  content={
                    <div
                      className="p-10 black-border"
                      style={{ background: "#FFFF" }}
                    >
                      {text_definition("segment_info")}
                    </div>
                  }
                >
                  <ActionInfo />
                </Tooltip>
                {/*
                <TooltipNormal
                  placement="left"
                  overlay={text_definition("segment_info")}
                  arrowContent={<div className="rc-tooltip-arrow-inner" />}
                >
                  <ActionInfo />
              </TooltipNormal>*/}
              </span>
            </div>
          </Row>
        </div>

        <Row className="no-margin-bottom pb-10">
          <Col xs="1" sm="1" md="1" lg="1">
            <MaterialPopover
              open={this.state.openCancel}
              anchorEl={this.state.cancelAnchorEl}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              targetOrigin={{ horizontal: "left", vertical: "center" }}
              onRequestClose={this.handleRequestClose}
            >
              <FullRow className="text-default">
                Are you sure you want to exit?
                <br />
                Any selections you have made will not be saved
                <br />
                <br />
                <a
                  className="btn btn-link btn-sm cancel-btn mr-20 text-bold"
                  onClick={e => {
                    this.handleOpenCancelDialog(e, false);
                  }}
                >
                  Close
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <a
                  className="btn btn-default btn-round btn-sm btn-aa-primary ml-20"
                  onClick={e => {
                    e.preventDefault();
                    window.location =
                      "/segments/list/active" +
                      (this.props.selected_client
                        ? `?cid=${this.props.selected_client}`
                        : "");
                  }}
                >
                  Yes, exit
                </a>
              </FullRow>
            </MaterialPopover>
            <a
              className="btn btn-link cancel-btn "
              style={{ marginLeft: "-5px" }}
              onClick={e => {
                this.handleOpenCancelDialog(e, true);
              }}
            >
              Cancel
            </a>
          </Col>
          <Col
            xs="11"
            sm="11"
            md="11"
            lg="11"
            className="text-right"
            style={{ position: "relative" }}
          >
            <RaisedButton
              disabled={
                !(this.props.plotted_values || hasSelectedSegments) ||
                !this.props.segment_name ||
                (this.props.segment_name === "" &&
                  this.props.copy_segment_name.length > 0)
              }
              backgroundColor={primaryColor()}
              labelColor="#FFF"
              onClick={this.gotoNext.bind(this)}
              onMouseOver={() => this.nextButtonHover(hasSelectedSegments)} // author chargo
              onMouseOut={() => this.nextButtonMouseOut()} // author chargo
              style={{
                marginRight: "3em",
                marginBottom: "10px",
                backgroundColor: primaryColor(),
              }}
              label="Next"
            />
            {/*author chargo*/}
            {this.state.toolTipStatus && !this.state.plotted_values && (
              <div
                className="tool-tip"
                style={{
                  position: "absolute",
                  fontSize: "12px",
                  textAlign: "left",
                  top: 0,
                  width: "18em",
                  right: "13em",
                  padding: "6px",
                  border: "1px solid rgb(211, 211, 211)",
                  borderRadius: "0.2em",
                }}
              >
                You must select at least one attribute and name this segment to
                continue.
              </div>
            )}
            {this.state.plotted_values != null && this.state.toolTipStatus && (
              <div
                className="tool-tip"
                style={{
                  position: "absolute",
                  fontSize: "12px",
                  textAlign: "left",
                  top: 0,
                  width: "18em",
                  right: "13em",
                  padding: "6px",
                  border: "1px solid rgb(211, 211, 211)",
                  borderRadius: "0.2em",
                }}
              >
                Please apply your change of plotted radius.
              </div>
            )}
            {/*the end*/}
          </Col>
        </Row>
        <LimitExceededForm
          showSaveErrorDialog={this.state.showSaveErrorDialog}
          history={this.props.history}
          showSuccessForm={this.state.showSuccessForm}
          openContactForm={this.state.openContactForm}
          roleId={this.props.roleId}
          openContactFormClick={this.openContactFormClick.bind(this)}
          cancelContactForm={this.cancelContactForm.bind(this)}
          onContactFormSubmit={this.onContactFormSubmit.bind(this)}
        />
      </div>
    );
  }
}

export default Creation;



// WEBPACK FOOTER //
// ./src/components/Segment/Creation/index.js